export type PartnerAccessProjectId = number | string;

export interface PartnerAccessAccount {
  via_partner_access?: boolean;
  partner_access_project_id?: PartnerAccessProjectId;
  [key: string]: any;
}

export const isPartnerAccessAccount = (account?: PartnerAccessAccount | null): boolean =>
  account?.via_partner_access === true;

export const getPartnerAccessProjectId = (
  account?: PartnerAccessAccount | null,
): PartnerAccessProjectId | undefined => {
  if (!isPartnerAccessAccount(account)) return undefined;
  const projectId = account?.partner_access_project_id;
  if (projectId == null || String(projectId).trim() === '') return undefined;
  return projectId;
};

export const buildPartnerAccessPlanNavigation = (projectId: PartnerAccessProjectId) => ({
  screen: 'Plans',
  params: {
    screen: 'ProjectHome',
    params: { projectId },
  },
});

export const shouldOpenCustomerPlanDirectly = (
  customer: { projects_count?: number | string | null } | null | undefined,
  canAccessPlans: boolean,
): boolean => canAccessPlans && Number(customer?.projects_count) === 1;

export const getSingleCustomerProject = (projects: unknown): any | undefined =>
  Array.isArray(projects) && projects.length === 1 ? projects[0] : undefined;
